<template>
  <div class="previewCarousel">
    <div
      class="nav-box"
      v-for="(item, index) in imgList"
      :key="index"
      :class="`${index % 2 == 0 ? (index == 2 ? 'w640' : 'w1040') : index == 3 ? 'w1040' : 'w640'} ${item.imgClassName}`"
      ref="Automotive"
    >
      <h2>{{ item.title }}</h2>
      <div class="nav-hash">
        <p v-for="(items, index) in item.hashList" :key="items.text">
          <router-link :to="{ name: item.name, hash: items.hash }">
            {{ items.text }}
          </router-link>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imgList: Array,
  },
};
</script>
<style lang="less" scoped>
.previewCarousel {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: center;
  gap: 2%;
  margin-bottom: 40px;
  .nav-box {
    aspect-ratio: 1040 / 665;
    transition: all 0.2s ease;
    overflow: hidden;
    text-align: center;
    position: relative;
    margin-bottom: 2%;
    // .photography-h2 {
    //   padding: 0 80px;
    // }

    h2 {
      width: 500px;
      height: 106px;
      display: flex;
      align-items: flex-end;
      position: absolute;
      top: calc(50% - 53px);
      left: calc(50% - 250px);
      font-size: 40px;
      color: #fff;
      transition: all 0.2s ease;
      justify-content: center;
    }

    .nav-hash {
      width: 100%;
      position: absolute;
      top: 100%;
      text-align: center;
      p {
        color: #fff;
        font-size: 20px;
        margin-bottom: 2.5%;
      }
      transition: all 0.3s ease;
      opacity: 0;

      a {
        font-size: 20px;
      }
    }
  }
  .nav-box:hover {
    h2 {
      top: calc(50% - 53px - 106px);
    }
    .nav-hash {
      opacity: 1;
      top: calc(50% - 25px);
    }
  }
  .nav-box:first-child {
    h2 {
      width: 600px;
      left: calc(50% - 300px);
    }
  }
  .nav-box:first-child:hover {
    h2 {
      top: calc(50% - 53px - 125px);
    }
    .nav-hash {
      opacity: 1;
      top: calc(50% - 53px);
    }
  }
  .w1040 {
    width: 58%;
  }
  .w640 {
    width: 37%;
  }
  .home1 {
    background: url(/public/image/home/home1.jpg) center center;
    background-size: 100%;
  }
  .home2 {
    background: url(/public/image/home/home2.jpg) center center;
    background-size: 100%;
  }
  .home3 {
    background: url(/public/image/home/home3.jpg) center center;
    background-size: 100%;
  }
  .home4 {
    background: url(/public/image/home/home4.jpg) center center;
    background-size: 100%;
  }
  .home5 {
    background: url(/public/image/home/home5.jpg) center center;
    background-size: 100%;
  }
  .home6 {
    background: url(/public/image/home/home6.jpg) center center;

    background-size: 100%;
  }
}
</style>
